/**
 * @generated SignedSource<<c8f01540bfe276b7a61193f105797f86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespNullSearchResults_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedNullSearchRelatedItems_viewer" | "SharedRecentlyFavoritedItems_viewer">;
  readonly " $fragmentType": "SbRespNullSearchResults_viewer";
};
export type SbRespNullSearchResults_viewer$key = {
  readonly " $data"?: SbRespNullSearchResults_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespNullSearchResults_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespNullSearchResults_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedNullSearchRelatedItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRecentlyFavoritedItems_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "819f459ba25d09f11ab2500e1972668e";

export default node;
